export enum ERoadSegment {
  BULK = 'Bulk',
  EXPRESS = 'Express',
  FTL = 'FTL',
  GROUPAGE = 'Groupage',
  LTL = 'LTL',
  MILK_RUNS = 'Milk Runs',
  PACKAGED = 'Packaged',
  PARCEL = 'Parcel',
  PTL = 'PTL',
}
